export class ApiEndPointsContact {
    getContactListing = 'api/Core/GetCores';
    getFavoriteContactListing = 'api/CoreFavorite/GetFavoriteCores';
    getContactFeildList = 'api/Core/GetAllFolderFields';    
    saveContactFieldList = 'api/Core/AddCore';
    saveContactUserDetails = 'api/Core/UpdateCore';
    getContactUserDetails = 'api/Core/GetCoreDetail';
    getContactFieldColumn = 'api/CustomizedGridComponent/GetUserGridCustomizedSetting';
    updateContactFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    ReorderContactFieldColumn = 'api/CustomizedGridComponent/ReorderColumn';
    getImageUploadURL ='api/App/UploadProfilePic';

    getDefaultFilterFieldsList = 'api/Filter/GetDefaultFilterFields';
    CreateFilter = 'api/Filter/AddFillter'; 
    GetAllFillters = 'api/Filter/GetAllFillters'; 
    GetFilteredContacts = 'api/Core/GetFilteredCores'; 
    DeleteContactTransaction = 'api/Core/DeleteCore'; 
    FavoriteContactTransaction ='api/CoreFavorite/AddCoreFavorite';
    FavoriteDeleteContactTransaction ='api/CoreFavorite/DeleteCoreFavorite';
}
